import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppState, ShowRequest} from '../../core';

import { PostProcessingService } from '../../core/services';
import { StatMetric, TableViewComponentBase, TableViewQueryRequest } from '../../shared/components/table-view/table-view-component-base';
import { HandsetTableCellComponent } from './handset-table-cell.component';
import { Handset } from '../../core/models/handset'


@Component({
  selector: 'app-handset-table',
  templateUrl: '../../shared/components/table-view/table-view.component.html',
  styleUrls: [
    '../../shared/components/table-view/scss/table-view.scss',
    '../../shared/components/table-view/scss/app-tab-full-height.scss',
    '../../shared/components/table-view/scss/fixed-headers-and-column.scss'
  ]
})
export class HandsetTableComponent extends TableViewComponentBase<Handset> implements OnInit, OnDestroy {

  constructor(
      appState: AppState,
      modalService: BsModalService,
      public postProcessingService: PostProcessingService,
      elementRef: ElementRef,
      datePipe: DatePipe
  ){
    super(appState,modalService,elementRef,datePipe)
    this.tableCellRenderer = HandsetTableCellComponent
    this.tableColumns  = [
      { title:'Stage', name: 'stage', visible: true},
      { title:'Market', name: 'market', visible: true},
      { title:'Carrier', name: 'carrier', visible: true},
      { title:'Participant', name: 'participant', visible: true},
      { title:'Number', name: 'number', visible: true},
      { title:'OS', name: 'os', visible: true},
      { title:'Make', name: 'make', visible: true},
      { title:'Model Name', name: 'modelname', visible: true},
      { title:'Model', name: 'model', visible: true},
      { title:'IMEI', name: 'imei', visible: true},
      { title:'Mode', name: 'mode', visible: true},
      { title:'Comments', name: 'comments', visible: true},
      { title:'BT MAC', name: 'btmac', visible: true},
      { title:'Baro', name: 'baro', visible: true},
      { title:'Height Offset', name: 'heightoffset', visible: true},
      { title:'Introduced', name: 'introduced', visible: true, template: 'date'},
      { title:'Retire Date', name: 'retireddate', visible: true, template: 'date'},
    ]
    this.maxSortColumns = 4
    this.sortColumns = [
      { key: 'stage', order: 'ASC'},
      { key: 'market', order: 'ASC'},
      { key: 'carrier', order: 'ASC'},
      { key: 'participant', order: 'ASC'},
    ];
    const metrics: StatMetric[] = [
      { column: 'heightoffset', statTypes: ['min','max','avg']},
      { column: 'introduced', statTypes: ['min','max'], format: { dataType: 'date', layout: 'short' } },
      { column: 'retireddate', statTypes: ['min','max'], format: { dataType: 'date', layout: 'short' } },
      { column: '*', format: { dataType: 'number' }, statTypes: ['count']}
    ];
    this.statGroups = [
      {
        id: 'stage',
        groupBy: ['stage'],
        visible: true,
        metrics,
      },
      {
        id: 'market',
        groupBy: ['market'],
        metrics,
      },
      {
        id: 'carrier',
        groupBy: ['carrier'],
        metrics,
      },
      {
        id: 'participant',
        groupBy: ['participant'],
        metrics,
      },
      {
        id: 'os',
        groupBy: ['os'],
        metrics,
      },
      {
        id: 'model',
        groupBy: ['model'],
        metrics,
      },
      {
        id: 'modelname',
        groupBy: ['modelname'],
        metrics,
      },
    ];
  }


  ngOnInit(): void {
    this.init()
  }


  ngOnDestroy(): void {
    this.destroy()
  }

  showMissing() {
    this.showTabFn( new ShowRequest('tab', 'missing handsets', null, null))
  }

  doQuery = async ( queryReq:TableViewQueryRequest ) => this.postProcessingService.findHandsets(queryReq)

}
